module.exports = __webpack_public_path__ + "img/Belgian.b2e0bd65.svg";